import React from 'react'

const Footer = (props) => (
    <footer id="footer">
        <div className="inner">
            <ul className="icons">
                <li><a href="mailto:oskarhostlund@gmail.com" className="icon alt fa-envelope"><span className="label">Email</span></a></li>
                <li><a href="https://linkedin.com/in/oskarhostlund" className="icon alt fa-linkedin"><span className="label">LinkedIn</span></a></li>
                <li><a href="https://github.com/hoestlund" className="icon alt fa-github"><span className="label">GitHub</span></a></li>
            </ul>
            <ul className="copyright">
                <li>Oskar Höstlund</li><li>Built using Gatsby.js</li><li>Design Starter: <a href="https://html5up.net">HTML5 UP</a></li>
            </ul>
        </div>
    </footer>
)

export default Footer
